import { IApplicationState, TBoardId } from '../../../../types/types';
import { IWebhook } from '../../../../types/rest/IRestUserBoardMeta';
import { getBoardUserMeta } from 'app/store/model/boardUserMetas/selectors/getBoardUserMeta';

export const getBoardUserMetaWebhooks = (
    state: IApplicationState,
    boardId: TBoardId
): IWebhook => {
    const userMeta = getBoardUserMeta(state, boardId);

    return userMeta && userMeta.webhooks;
};
